import React from 'react';
import { cx } from '../cx';

// D-09 §15.21 — Segmented (.segment > button[.active]) · controlled
// size: 높이는 control-height(sm 32 / md 36 / lg 48) — Input(§15.2)과 동일 스케일
export interface SegmentedOption {
  label: string;
  value: string;
}
export interface SegmentedProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md' | 'lg';
}

export function Segmented({ options, value, onChange, size = 'md', className = '', ...props }: SegmentedProps) {
  return (
    <div className={cx('segment', size !== 'md' && `segment-${size}`, className)} {...props}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={o.value === value ? 'active' : ''}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
